import { hydrateRoot } from 'react-dom/client';
import { createElement } from 'react';
import { decodeDataProps } from '@finn-no/tjt-common-utils';
import { DataProps } from './types/uiTypes';
import App from './App';
import 'uno.css';

class CreateOfferButton extends HTMLElement {
    constructor() {
        super();
        try {
            const props = CreateOfferButton.getProps(); // querySelector('create-offer-button'),

            // @ts-ignore
            const el = document
                .querySelector('tjt-podlet-create-offer-button-isolated')
                .shadowRoot.querySelector('#tjt-create-offer-button') as HTMLElement;
            hydrateRoot(el, createElement(App, { ...props }));
        } catch (e) {
            /**
             * We have experienced that the div with id #tjt-create-offer-button is not loaded for all users.
             * This results in just the SSR being loaded, but no JavaScript, so the users can not use Fiks Ferdig.
             * The workaround has been to set a timeout of 500ms to re-hydrate the app.
             */

            console.error(e);

            setTimeout(() => {
                const props = CreateOfferButton.getProps();
                this.innerHTML = '<div id="create-offer-button"></div>';
                // @ts-ignore
                const el = document
                    .querySelector('tjt-podlet-create-offer-button-isolated')
                    .shadowRoot.querySelector('#tjt-create-offer-button') as HTMLElement;
                hydrateRoot(el, createElement(App, { ...props }));
            }, 500);
        }
    }

    // Get the props from the custom element and throw an error if we can not find them
    static getProps() {
        const props = decodeDataProps<DataProps>(
            // @ts-ignore
            document
                .querySelector('tjt-podlet-create-offer-button-isolated')
                .shadowRoot.querySelector('create-offer-button'),
        );
        if (!props) {
            throw new Error('TJT error: Failed to get props.');
        }
        return props;
    }
}

if (!customElements.get('create-offer-button')) {
    customElements.define('create-offer-button', CreateOfferButton);
}
